import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import {
  getInvoiceSettings,
  updateInvoiceSettings,
} from "../../store/slices/InvoiceSettingsSlice";
import DropdownComponent from "../../components/Shared/DropdownComponent";
import SwitchInput from "../../components/Shared/SwitchInput";
import SharedButton from "../../components/Shared/SharedButton";
import NewSettingsList from "./NewSettingsList";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData } from "../../helpers/fetchData";
import toast from "react-hot-toast";

const NewSettings = () => {
  const { t } = useTranslation();
  const lang = i18next.language;
  const dispatach = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const [openSettingForm, setOpenSettingForm] = useState(false);
  const [invoiceSettingsOptions, setInvoiceSettingsOptions] = useState({
    coaCheck: "",
    companyInvoiceSize: "",
    saleInvoiceSize: "",
    companyCoaCheck: "",
    customerCoaCheck: "",
  });
  const { invoiceSettings, isLoading } = useSelector(
    (state) => state?.invoiceSettings,
  );
  const isAllowEdit = invoiceSettings?.coaCheck?.value == "true";

  const coaTypesOptions = [
    { value: true, label: lang == "ar" ? "نشيط" : "Active" },
    { value: false, label: lang == "ar" ? "في نشط" : "In Active" },
  ];

  const invocieSizeoptions = [
    { value: "a4", label: "A4" },
    { value: "a2", label: "A2" },
  ];

  useEffect(() => {
    dispatach(getInvoiceSettings());
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    setInvoiceSettingsOptions((prev) => ({
      ...prev,
      coaCheck: invoiceSettings?.coaCheck?.value == "false" ? false : true,
      companyInvoiceSize: invoiceSettings?.companyInvoiceSize?.value,
      saleInvoiceSize: invoiceSettings?.saleInvoiceSize?.value,
      companyCoaCheck:
        invoiceSettings?.companyCoaCheck?.value == "false" ? false : true,
      customerCoaCheck:
        invoiceSettings?.customerCoaCheck?.value == "false" ? false : true,
    }));
  }, [invoiceSettings]);

  const handleUpdateSettings = (event, fieldName) => {
    let selectedObj = { ...invoiceSettings[fieldName] };
    selectedObj.value = String(event?.value);
    if (selectedObj) {
      let payload = {
        id: selectedObj?.id,
        data: selectedObj,
      };
      setInvoiceSettingsOptions((prev) => ({
        ...prev,
        [fieldName]: event.value,
      }));
      dispatach(updateInvoiceSettings(payload)).then((res) => {
        if (
          fieldName == "coaCheck" &&
          res?.meta?.requestStatus === "fulfilled"
        ) {
          dispatach(getInvoiceSettings());
        }
      });
    }
  };


  return (
    <div>
      <div className="flex flex-col gap-3">
        <div className={`flex flex-wrap items-end gap-2 ${lang == 'ar' ? '' : "justify-end"}`}>
          <div className="w-full sm:w-[240px]">
            <DropdownComponent
              useFormik={false}
              label={t("select_company_invoice_size")}
              value={invoiceSettingsOptions?.companyInvoiceSize}
              options={invocieSizeoptions}
              optionLabel="label"
              placeholder={t("select_company_invoice_size")}
              onChange={(e) => handleUpdateSettings(e, "companyInvoiceSize")}
              disabled={isLoading}
            />
          </div>
          <div className="w-full sm:w-[240px]">
            <DropdownComponent
              useFormik={false}
              label={t("select_sales_invoice_size")}
              value={invoiceSettingsOptions?.saleInvoiceSize}
              options={invocieSizeoptions}
              optionLabel="label"
              placeholder={t("select_sales_invoice_size")}
              onChange={(e) => handleUpdateSettings(e, "saleInvoiceSize")}
              disabled={isLoading}
            />
          </div>
          {invoiceSettings?.coaCheck == null ||
            invoiceSettings?.coaCheck?.value == "false" ? (
            <SwitchInput
              value={invoiceSettingsOptions?.coaCheck}
              label={t("coa")}
              onChange={async () => {
                const res = await fetchData("POST", "/enableCoa");
                toast.success(res?.message);
                dispatach(getInvoiceSettings());
              }}
              disabled={isLoading}
              className="!w-16"
            />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <SwitchInput
                  value={invoiceSettingsOptions?.coaCheck}
                  label={t("coa")}
                  onChange={(e) => handleUpdateSettings(e, "coaCheck")}
                  disabled={isLoading}
                />
              </div>
              <SharedButton
                type="button"
                icon="pi pi-plus"
                label={t("Create Setting")}
                onClick={() => navigate("/manager/settings/create")}
              />

              <SharedButton
                type="button"
                icon="pi pi-plus"
                label={t("Create GL Settings")}
                onClick={() => navigate("/manager/settings/gl/create")}
              />
              <SharedButton
                type="button"
                icon="pi pi-credit-card"
                label={t("payment Settings")}
                onClick={() => navigate("/manager/settings/payment/create")}
              />
              <SharedButton
                type="button"
                icon="pi pi-cog"
                label={t("Create Payer Settings")}
                onClick={() => navigate("/manager/settings/payer/create")}
              />


            </>
          )}
        </div>

        <NewSettingsList
          setOpenSettingForm={setOpenSettingForm}
          openSettingForm={openSettingForm}
        />
      </div>
      {/* <CustomTabs tabs={tabs} activeTabIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)} /> */}
    </div>
  );
};

export default NewSettings;
